/**
 * Personel sertifika dosyası ve kontrat belgesi (04.11 notları B5, B6; ADR 0164): PDF, JPG ya da
 * PNG, en çok 10 MB; yeni dosya eskisini silmez; her açılış kayda geçer.
 */

export const crewFilesEn = {
  open: 'Open file: {{name}}',
  versions: '{{count}} versions',
  upload: 'Upload file',
  uploadNewVersion: 'Upload new version',
  uploading: 'Uploading…',
  uploaded: 'File uploaded. The previous file is kept as an earlier version.',
  uploadFailed: 'The file could not be uploaded.',
  hint: 'PDF, JPG or PNG, up to 10 MB.',
  notOnBoard: 'Not on board yet',
  notOnBoardHelp:
    'The file has not been downloaded to this vessel yet. It opens here once the download finishes.',
  close: 'Close',
  contract: {
    column: 'Documents',
    none: 'No documents',
    upload: 'Upload document',
    uploadFor: 'Upload contract document for {{vessel}}',
    count: '{{count}} documents',
    officeOnly: 'Contract documents stay in the office; they are not sent to the vessel.',
  },
  errors: {
    FILE_TOO_LARGE: 'The file is larger than 10 MB.',
    FILE_TYPE_MISMATCH: 'Only PDF, JPG and PNG files can be uploaded.',
    FORBIDDEN: 'You do not have permission for this.',
  },
};

export const crewFilesTr: typeof crewFilesEn = {
  open: 'Dosyayı aç: {{name}}',
  versions: '{{count}} sürüm',
  upload: 'Dosya yükle',
  uploadNewVersion: 'Yeni sürüm yükle',
  uploading: 'Yükleniyor…',
  uploaded: 'Dosya yüklendi. Önceki dosya eski sürüm olarak saklanır.',
  uploadFailed: 'Dosya yüklenemedi.',
  hint: 'PDF, JPG ya da PNG, en çok 10 MB.',
  notOnBoard: 'Henüz gemide değil',
  notOnBoardHelp: 'Dosya bu gemiye henüz inmedi. İndirme bitince burada açılır.',
  close: 'Kapat',
  contract: {
    column: 'Belgeler',
    none: 'Belge yok',
    upload: 'Belge yükle',
    uploadFor: '{{vessel}} kontratına belge yükle',
    count: '{{count}} belge',
    officeOnly: 'Kontrat belgeleri ofiste kalır; gemiye gönderilmez.',
  },
  errors: {
    FILE_TOO_LARGE: 'Dosya 10 MB’tan büyük.',
    FILE_TYPE_MISMATCH: 'Yalnız PDF, JPG ve PNG dosyası yüklenebilir.',
    FORBIDDEN: 'Bu işlem için yetkiniz yok.',
  },
};
